import { Draggable, Droppable } from '@hello-pangea/dnd';

import { v4 as uuid } from 'uuid';

import { FormItem } from '../../../models/Inquiry/Inquiry';

interface Props {
  data: FormItem[]
  isLoading: boolean
  droppableId: string
  customTitle?: string
  hasBlankOption?: boolean
}

export default function LayoutItems({
  data,
  isLoading,
  droppableId,
}: Props): JSX.Element {
  const blankKey = `empty_${uuid()}`;

  return (
    <>
      <div className="fw-bold mb-1">＜項目一覧＞</div>
      {
        isLoading && (
          <div className="spinner-border spinner-border-sm text-primary mt-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )
      }
      <Droppable
        isDropDisabled
        droppableId={droppableId}
      >
        {(provided) => (
          <div
            ref={provided.innerRef}
            className="list-group gap-1 webdb-list-additems"
            style={{ minHeight: '200px' }}
          >
            {!isLoading && (
              <>
                <Draggable
                  key={blankKey}
                  index={data.length}
                  draggableId={blankKey}
                  data-testid="blank-option"
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className="user-select-none list-group-item list-group-item-action"
                      style={{ ...provided.draggableProps.style }}
                    >
                      <div className="d-flex align-items-center">
                        <i className="fa-solid fa-bars fa-fw me-2" />
                        空白
                      </div>
                    </div>
                  )}
                </Draggable>

                {data?.map((item, index) => (
                      <Draggable
                        key={item.uuid}
                        index={index}
                        draggableId={String(item.uuid)}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className="user-select-none list-group-item list-group-item-action"
                            style={{
                              ...provided.draggableProps.style,
                              display: item.hide ? 'none' : 'block',
                            }}
                          >
                            <div className="d-flex align-items-center">
                              <i className="fa-solid fa-bars fa-fw me-2" />
                              {item.label}
                            </div>
                          </div>
                        )}
                      </Draggable>
                ))}
              </>
            )}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
}
